import { observer } from "mobx-react-lite";

import LightSwitch from "@/components/ui/LightSwitch";

const AndOrToggle = ({ checked = true, onChange }: { checked: boolean; onChange: () => void }) => (
  <div className="mx-auto mt-2 flex w-min cursor-pointer items-center gap-4 rounded-lg">
    <LightSwitch
      isOn={checked}
      onLabel="AND"
      offLabel="OR"
      size="sm"
      onToggle={() => {
        onChange();
      }}
    />
  </div>
);

export default observer(AndOrToggle);
